/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IDetailsListStyles } from "@fluentui/react";

export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    borderRadius: "8px",
    height: "100%",
    padding: "23px",
    paddingTop: "0",
    border: "1px solid #C8C8C8",
    marginBottom: "1.5rem",
  },
};
